import { LoaderFunction, useFetcher } from "react-router-dom";
import { AccessCode } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";
import { redeemAccessCode } from "../../../../common/api/decimal/methods/courseware.ts";

export const revealCode: LoaderFunction = async ({
  params,
}): Promise<DecimalResult<AccessCode>> => {
  if (params.vbid) {
    return redeemAccessCode(params.vbid);
  }
  return { ok: false, meta: {} };
};

export function useRevealFetcher() {
  return useFetcher<DecimalResult<AccessCode>>();
}
